"use strict";

define('rs/form/formobjects/person.finder/person.finder.formobject',['require','exports','module','rs/form/abstract.form.entity','rs/form/formobjects/base.formobject','rs/form/formobjects/person.finder/person.finder.formobject.view','rs/models/assignment.builder','rs/models/person','rs/models/training','rs/modals/person.finder/person.finder.controller','rs/modals/training.finder/training.finder.controller','rs/helper','e3-table'],function (require, exports, module) {
  var AbstractFormEntity = require('rs/form/abstract.form.entity');
  var BaseFormObject = require('rs/form/formobjects/base.formobject');
  var PersonFinderFormObjectView = require('rs/form/formobjects/person.finder/person.finder.formobject.view');
  var AssignmentBuilder = require('rs/models/assignment.builder');
  var Person = require('rs/models/person');
  var Training = require('rs/models/training');
  var PersonFinder = require('rs/modals/person.finder/person.finder.controller');
  var TrainingFinder = require('rs/modals/training.finder/training.finder.controller');
  var helper = require('rs/helper');
  var E3Table = require('e3-table');
  var PersonFinderFormObject = BaseFormObject.extend({
    propertiesDefinitions: ['name', 'label', 'hasMultiple', 'required', 'assignmentType', 'text', 'description', 'helpText'],
    properties: ['assignmentType', 'displayTable', 'hasMultiple', 'persons', 'ariaControlsId'],
    columns: [{
      name: 'displayName',
      displayName: 'Name',
      width: '20%'
    }, {
      name: 'organization',
      displayName: 'Organization',
      width: '15%'
    }, {
      namespace: 'primaryAddress.fullAddress',
      displayName: 'Address',
      width: '20%'
    }, {
      namespace: 'primaryPhone.fullNumber',
      displayName: 'Phone',
      width: '10%'
    }, {
      namespace: 'primaryEmail.emailAddress',
      displayName: 'Email',
      width: '20%'
    }, {
      name: 'trainingLink',
      displayName: 'Trainings',
      className: 'open-person-training-cell',
      width: '10%',
      isButton: true
    }, {
      accessibleDisplayName: 'Remove',
      remove: true,
      isButton: true,
      className: 'remove-person-finder-cell',
      width: '5%'
    }],
    initialize: function initialize() {
      var persons = null,
        columns = this.columns.slice(0);
      this.setPersons([]);
      this._super.apply(this, arguments);
      if (this.isDesignerMode()) {
        this.sync('assignmentType', {
          trigger: true
        });
      }
      this.sync('persons');
      this.setAriaControlsId('fo-' + this.getId());
      if (!this.getFormController().canEditDocument()) {
        columns.pop();
        columns[columns.length - 1].width = '30%';
      } else {
        columns[columns.length - 2].width = '25%';
      }
      this.setDisplayTable(new E3Table.AccordionController({
        columns: columns,
        delegate: this,
        selectable: false,
        theme: 'rs',
        ariaLabel: 'current selection for ' + this.getLabeledText(),
        ariaDescribedBy: this.getId() ? "fo-" + this.getId() + '-text' : ''
      }));
    },
    setPersons: function setPersons(value) {
      if (_.isArray(value)) {
        for (var i = 0, len = value.length, person; i < len; i++) {
          person = value[i];
          if (!(person instanceof Person)) {
            value[i] = new Person(person);
          }
        }
      }
      this.set('persons', value);
    },
    importAnswers: function importAnswers() {
      var persons = null,
        assignments = null;
      if (this.hasAssignmentType()) {
        this.getFormController().addAssignmentFormObject(this);
        if (!this.getFormController().hasAnswers()) {
          assignments = this.getFormController().getAssignments();
          persons = assignments.getPersonsByAssignmentType(this.getAssignmentType());
          if (!this.getHasMultiple() && persons.length > 1) {
            persons = persons.slice(0, 1);
          }
          if (persons.length > 0) {
            this.setPersons(persons);
            this.requestValueChange();
            this.getSectionController().setUnsavedChanges(true);
          }
        }
      }
    },
    isAnswerable: true,
    setupView: function setupView() {
      this.setView(new PersonFinderFormObjectView());
    },
    getCompareValue: function getCompareValue() {
      return JSON.stringify((_.pluck(this.getPersons(), 'id') || []).sort());
    },
    getAssignmentTypes: function getAssignmentTypes() {
      var assignmentTypes = this.getFormController().getPersonAssignmentTypes(this),
        that = this;
      return _.reject(assignmentTypes, function (assignment) {
        return that.isAssignmentLocked(assignment.description);
      });
    },
    hasAssignmentType: function hasAssignmentType() {
      return this.getAssignmentType() != null;
    },
    personsDidChange: function personsDidChange() {
      this.refreshValidity();
    },
    setValue: function setValue(v) {
      var persons = [];
      try {
        persons = JSON.parse(v);
      } catch (e) {}
      this.setPersons(persons);
    },
    mapAssignmentTypePropertyValue: function mapAssignmentTypePropertyValue(value) {
      return AssignmentBuilder.getNameFromAssignmentTypeObject(value);
    },
    getSelectedAssignmentIndex: function getSelectedAssignmentIndex(value, assignments) {
      var names = _.map(assignments, function (obj) {
        return AssignmentBuilder.getNameFromAssignmentTypeObject(obj);
      });
      return _.indexOf(names, value);
    },
    updatePersonInfo: function updatePersonInfo() {
      var that = this,
        persons = this.getPersons();
      if (persons.length) {
        return this._updatePersonsDeferred = Promise.map(persons, function (person) {
          return Person.requestDetails(person.id).ignoreErrors();
        }).then(function (newPersons) {
          if (_.isArray(newPersons)) {
            that.setPersons(newPersons);
          }
        });
      }
    },
    loadData: function loadData() {
      var data = this.getFormController().getFormObjectDataByID(this.getId()),
        persons = [];
      try {
        persons = JSON.parse(data);
      } catch (e) {}
      if (_.isArray(persons)) {
        this.setPersons(Person.models(persons), {
          silent: true
        });
      }
      this.updatePersonInfo();
    },
    checkValue: function checkValue() {
      if (this.getFormController().isPreviewMode()) {
        return true;
      }
      return this.getPersons().length > 0;
    },
    getValue: function getValue() {
      return JSON.stringify(this.getPersons());
    },
    requestValueChange: function requestValueChange() {
      this.trigger('change:value');
    },
    refreshPersonsPropertyOnView: function refreshPersonsPropertyOnView() {
      this.getView().refreshFormObjectWithValue();
    },
    removePersonAtIndex: function removePersonAtIndex(index) {
      if (this.isReadOnly()) {
        return;
      }
      var that = this;
      return Promise.resolve(this._updatePersonsDeferred).bind(this).then(this.testSet).lastly(this.getFormController().showLoading()).then(function () {
        var persons = that.getPersons();
        persons.splice(index, 1);
        that.trigger('change:persons');
        that.requestValueChange();
      });
    },
    assignmentTypeDidChange: function assignmentTypeDidChange(assignment, previousAssignment) {
      if (previousAssignment) {
        this.setAssignemntLock(previousAssignment, false);
      }
      if (!assignment) {
        this.unlockProperty('required');
        this.unlockProperty('hasMultiple');
        return;
      }
      var assignmentType = this.getFormController().getAssignmentTypeByDescription(assignment) || {};
      if (assignmentType.multiple === false) {
        this.lockProperty('hasMultiple', false);
      } else {
        this.unlockProperty('hasMultiple');
      }
      switch (assignment) {
        case 'PRINCIPAL_INVESTIGATOR':
          this.lockProperty('required', true);
          this.setAssignemntLock('PRINCIPAL_INVESTIGATOR', true);
          break;
        case 'PRIMARY_CONTACT':
          this.lockProperty('required', true);
          this.setAssignemntLock('PRIMARY_CONTACT', true);
          break;
        default:
          this.unlockProperty('required');
          break;
      }
    },
    loadAssignmentsToBuilder: function loadAssignmentsToBuilder(ab) {
      var assignmentType = this.getAssignmentType(),
        persons = this.getPersons(),
        person = null,
        i = 0;
      if (assignmentType) {
        if (persons.length) {
          for (i = 0; person = persons[i]; ++i) {
            ab.addPerson(person, assignmentType, {
              rawType: true
            });
          }
        } else {
          ab.addPerson(null, assignmentType, {
            rawType: true
          });
        }
      }
    },
    requestPersonModal: function requestPersonModal() {
      var that = this,
        assignmentType = String(this.getAssignmentType()).replace(/_/g, ' '),
        persons = null;
      return PersonFinder.show({
        title: assignmentType,
        items: this.getPersons(),
        multiSelect: this.getHasMultiple() || false,
        ariaControls: this.getAriaControlsId()
      }).then(function (_persons) {
        persons = _persons;
        return that.testSet().lastly(that.getFormController().showLoading());
      }).tap(function () {
        that.setPersons(persons || []);
        that.requestValueChange();
      });
    },
    requestTrainingModal: function requestTrainingModal(email) {
      return TrainingFinder.show({
        title: 'Trainings',
        multiSelect: false,
        loadAll: true,
        email: email
      });
    },
    setAssignemntLock: function setAssignemntLock(assignment, locked) {
      var formController = this.getFormController(),
        previousAssignmentController = formController.getAssignmentFormObject(assignment);
      if (!previousAssignmentController && locked === true) {
        formController.setAssignmentFormObject(assignment, this);
      } else if (previousAssignmentController === this) {
        formController.setAssignmentFormObject(assignment, null);
      }
    },
    getAssignmentLock: function getAssignmentLock(assignment) {
      var formController = this.getFormController(),
        assignmentController = this.getFormController().getAssignmentFormObject(assignment);
      if (assignmentController) {
        if (assignmentController === this) {
          return false;
        }
        return true;
      }
      return false;
    },
    isAssignmentLocked: function isAssignmentLocked() {
      return !!this.getAssignmentLock.apply(this, arguments);
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments),
        assignmentType = this.getAssignmentType();
      json.hasMultiple = this.getHasMultiple();
      json.assignmentType = assignmentType;
      return json;
    },
    getPDFDisplayData: function getPDFDisplayData() {
      var persons = this.getPersons(),
        columns = this.columns.slice(0, this.columns.length - 2),
        items = [];
      for (var i = 0; i < persons.length; i++) {
        items.push({
          cells: _.map(columns, function (c) {
            return {
              column: c.displayName,
              content: E3Common.Object.namespace(persons[i], c.name || c.namespace)
            };
          })
        });
      }
      return {
        items: items
      };
    },
    requiredIsLinked: function requiredIsLinked() {
      var defaultValue = this._super.apply(this, arguments);
      switch (this.assignmentType) {
        case 'PRINCIPAL_INVESTIGATOR':
        case 'PRIMARY_CONTACT':
          return true;
        default:
          return defaultValue;
      }
    },
    viewIsReady: function viewIsReady() {
      this._super.apply(this, arguments);
      this.getDisplayTable().setup(this.getView().getDisplayContainer());
      this.getDisplayTable().start();
    },
    getData: function getData() {
      return this.getPersons() || [];
    },
    removeTableItem: function removeTableItem(item) {
      return this.removePersonAtIndex(item.index);
    },
    isTableItemSelectable: function isTableItemSelectable() {
      return false;
    }
  }, {
    getTypeString: function getTypeString() {
      return 'PersonFinder';
    },
    propertiesDefinitions: _.extend({}, AbstractFormEntity.propertiesDefinitions, {
      hasMultiple: {
        name: 'hasMultiple',
        bool: true,
        displayName: 'Allow Multiple'
      },
      assignmentType: {
        name: 'assignmentType',
        dropdown: true,
        displayKey: 'displayName',
        values: 'getAssignmentTypes',
        selectIndex: 'getSelectedAssignmentIndex',
        displayName: 'Assignment'
      }
    })
  });
  module.exports = PersonFinderFormObject;
});

